// extracted by mini-css-extract-plugin
module.exports = {"container":"book-module--container--1ydJu","text":"book-module--text--3YLEj","image":"book-module--image--2K6Gp"};